var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Make sure that your Facebook Business Account has give permissions to Upper Quadrant's business account 164993337238214. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }